<tr>
  @for (column of columns(); track column.labelKey) {
    <th [class.text-right]="column.numeric">{{ column.labelKey | transloco }}</th>
  }
</tr>
